import React, { Dispatch, SetStateAction, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, ModalProps } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { toast } from 'react-toastify';
import { useCreatePartnerMutation } from 'src/redux/services/centralApi';

interface IAddPartnerForm {
	name: string;
}

export default function createPartner(
	{
		modalProps,
		onFinishAddPartnerForm: outter_onFinishAddPartnerForm,
		OpenButton,
	}: {
		onFinishAddPartnerForm?: (params: {
			setOpen: Dispatch<SetStateAction<boolean>>
			values: IAddPartnerForm
			form: FormInstance<IAddPartnerForm>
		}) => void
		modalProps?: (
			params: {
				setOpen: Dispatch<SetStateAction<boolean>>
				form: FormInstance<IAddPartnerForm>
			}
		) => ModalProps
		OpenButton?: React.FunctionComponent<{
			setOpen: Dispatch<SetStateAction<boolean>>
			form: FormInstance<IAddPartnerForm>
		}>
		Extra?: React.FunctionComponent<{
			setOpen: Dispatch<SetStateAction<boolean>>
			form: FormInstance<IAddPartnerForm>
		}>
	}
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ createPartner, createPartnerResult, ] = useCreatePartnerMutation();

	const [ addPartnerForm, ] = Form.useForm<IAddPartnerForm>();

	const onFinishAddPartnerForm = (data: IAddPartnerForm) => {
		if(outter_onFinishAddPartnerForm){
			outter_onFinishAddPartnerForm({
				values: data,
				setOpen,
				form: addPartnerForm,
			});
			return;
		}
		createPartner({
			name: data.name,
		})
			.unwrap()
			.then(() => {
				setOpen(false);
				addPartnerForm.resetFields();
				toast.success('Parceiro adicionado com sucesso!', {
					autoClose: 1000,
				});
			})
			.catch((err) => {
				if (err?.status && err?.status === 500
					&& err?.data?.frontend_message) {
					toast.error(err?.data?.frontend_message, {
						autoClose: 1000,
					});
				}
			});
	};

	return <>
		{
			OpenButton
				? <OpenButton setOpen={setOpen} form={addPartnerForm} />
				: <Button
					type="primary"
					onClick={() => {
						setOpen(!open);
					}}
					icon={<PlusOutlined />}
				>
					Adicionar
				</Button>
		}
		<Modal
			centered
			title={'Adicionar Parceiro'}
			open={open}
			onCancel={() => {
				setOpen(!open);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			confirmLoading={createPartnerResult.isLoading}
			okText="Salvar"
			onOk={() => {
				addPartnerForm.submit();
			}}
			{ ...(
				modalProps
					? modalProps({ setOpen, form: addPartnerForm, })
					: undefined
			) }
		>
			<Form
				layout="vertical"
				onFinish={onFinishAddPartnerForm}
				form={addPartnerForm}
				style={{ marginTop: 10, }}
			>
				<Form.Item
					name={'name'}
					hasFeedback
					required
					tooltip={'Insira o nome do parceiro.'}
					label={'Nome do parceiro'}
					rules={[
						{
							required: true,
							message: 'Campo obrigatório.',
						},
					]}
				>
					<Input placeholder="Nome do parceiro" />
				</Form.Item>
			</Form>
		</Modal>
	</>;
}